export default {
  badge: "Badge",
  close: "Tæt",
  dataIterator: {
    noResultsText: "Ingen matchende poster fundet",
    loadingText: "Indlæser varer...",
  },
  dataTable: {
    itemsPerPageText: "Rækker pr. side:",
    ariaLabel: {
      sortDescending: "Sorteret faldende.",
      sortAscending: "Sorteret stigende.",
      sortNone: "Ikke sorteret.",
      activateNone: "Aktiver for at fjerne sortering.",
      activateDescending: "Aktiver for at sortere faldende.",
      activateAscending: "Aktiver for at sortere stigende.",
    },
    sortBy: "Sorter efter",
  },
  dataFooter: {
    itemsPerPageText: "Varer pr. Side:",
    itemsPerPageAll: "Alle",
    nextPage: "Næste side",
    prevPage: "Forrige side",
    firstPage: "Første side",
    lastPage: "Sidste side",
    pageText: "{0}-{1} af {2}",
  },
  datePicker: {
    itemsSelected: "{0} valgte",
    nextMonthAriaLabel: "Næste måned",
    nextYearAriaLabel: "Næste år",
    prevMonthAriaLabel: "Forrige måned",
    prevYearAriaLabel: "Foregående år",
  },
  noDataText: "Ingen tilgængelig data",
  carousel: {
    prev: "Tidligere visuel",
    next: "Næste visuelle",
    ariaLabel: {
      delimiter: "Karruseldias {0} af {1}",
    },
  },
  calendar: {
    moreEvents: "{0} more",
  },
  fileInput: {
    counter: "{0} filer",
    counterSize: "{0} filer ({1} i alt)",
  },
  timePicker: {
    am: "AM",
    pm: "PM",
  },
  pagination: {
    ariaLabel: {
      wrapper: "Pagination Navigation",
      next: "Næste side",
      previous: "Forrige side",
      page: "Gå til side {0}",
      currentPage: "Aktuel side, Side {0}",
    },
  },
  rating: {
    ariaLabel: {
      icon: "Bedømmelse {0} af {1}",
    },
  },
};
